<div class="modal" mat-dialog-content>
    <div>
        <div class="icono centrado">
          <mat-icon [inline]="true">check_circle</mat-icon>
        </div>
        <br/>
        <div class="centrado" [innerHTML]="mensaje">
        </div>
        <br/>
        <div fxLayout="row" fxLayoutAlign="center center" class="botones">
            <div *ngFor="let item of buttons">
                <!-- <button *ngIf="item === 'cancel'" class="m-1 hover:bg-red-600" mat-raised-button color="warn" (click)="cancel()">Cancel</button> -->
                <button *ngIf="item === 'confirm'" mat-raised-button color="primary" (click)="confirm()">Aceptar</button>
                <!-- <button *ngIf="item === 'cancel'" mat-button class="cancel" (click)="cancel()">Cancelar</button> -->
                <button *ngIf="item === 'cancel'" class="cancel" (click)="cancel()">Cancelar</button>
            </div>
          <!-- <button mat-raised-button color="primary" (click)="confirm()">Enviar</button>
          <ng-container [ngTemplateOutlet]="bntCancelar"></ng-container> -->

          <!-- @for (item of buttons; track $index) {
            @if(item === 'cancel'){
                <button class="m-1 hover:bg-red-600" mat-raised-button color="warn" (click)="cancel()">Cancel</button>
            }
            @else if(item === 'confirm'){
                <button class="m-1 text-white hover:bg-blue-800" mat-raised-button color="primary" (click)="confirm()">Aceptar</button>
            }
        } -->
        </div>
      </div>
      
      
    <ng-template #bntCancelar>
        <button mat-raised-button color="accent" (click)="cancel()">Cancelar</button>
    </ng-template>
      
</div>